@use '../../../../app/styles/common/mixins';

$maxWidth: 480px;

.mainInfo {
  display: flex;
  flex-direction: column;
  gap: var(--spasing20);

  .mainInfoContent {
    position: relative;
  }

  .wrapper {
    padding: var(--spasing20);
    border-radius: var(--spasing16);
    outline: 1px solid var(--border-secondary);
    background: var(--surface-01);
  }

  @include mixins.laptop {
    max-width: $maxWidth;
  }

  .sellerDetails {
    @include mixins.tablet {
      margin-top: var(--spasing40);
    }
  }

  .offerTop {
    height: 36px;

    position: absolute;
    top: var(--spasing20);
    right: var(--spasing20);
  }
}
